<template>
  <Header/>
  <div id="main" class="width" style="margin-top: 30px;">
    <div class="imain">
      <!--首页banner-->
      <div class="slider">
        <div class="slides_container">
          <img :src="bannerHref" alt=""
               style=" width:664px; height:285px;"/>
        </div>
      </div>
      <!--新闻1-->
      <div class="ibox mr0">

        <h3><a href="/#/huLianWangJiaNews" target="_blank">互联网+新闻</a></h3>
        <ul>
          <li v-for="(item, index) in dataList.huLianWangJiaXinWen" :key="index">
            <span>[{{ item.post_date.split(" ")[0] }}]</span>
            <i>•</i>
            <a :href="'/#/detail?id=' + item.ID" target='_blank'
               :title='item.post_title'>
              {{ item.post_title }}
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div class="imain">
      <!--新闻2-->
      <div class="ibox itag">
        <h3><a href="/#/shiShiXinWen" target="_blank" title="时事新闻" class="on">时事新闻</a></h3>
        <div class="itag_main">
          <div class="itag_li">
            <ul>
              <li v-for="(item, index) in dataList.shiShiXinWen" :key="index">
                <span>[{{ item.post_date.split(" ")[0] }}]</span>
                <i>•</i>
                <a :href="'/#/detail?id=' + item.ID" target='_blank'
                   :title='item.post_title'>
                  {{ item.post_title }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!--新闻3-->
      <div class="ibox itag">
        <h3><a href="/#/hangYeZiXun" target="_blank" title="行业资讯" class="on">行业资讯</a></h3>
        <div class="itag_main">
          <div class="itag_li">
            <ul>
              <li v-for="(item, index) in dataList.hangYeZiXun" :key="index">
                <span>[{{ item.post_date.split(" ")[0] }}]</span>
                <i>•</i>
                <a :href="'/#/detail?id=' + item.ID" target='_blank'
                   :title='item.post_title'>
                  {{ item.post_title }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!--新闻4-->
      <div class="ibox itag mr0">
        <h3><a href="/#/gaoXinJiShu" target="_blank" title="高新技术" class="on">高新技术</a></h3>
        <div class="itag_main">
          <div class="itag_li">
            <ul>
              <li v-for="(item, index) in dataList.gaoXinJiShu" :key="index">
                <span>[{{ item.post_date.split(" ")[0] }}]</span>
                <i>•</i>
                <a :href="'/#/detail?id=' + item.ID" target='_blank'
                   :title='item.post_title'>
                  {{ item.post_title }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!--首页产品展示-->


    <div class="imain">
      <div class="ibox itag ">
        <h3><a href="/#/hangYeHuoDong" target="_blank" title="行业活动" class="on">行业活动</a></h3>
        <div class="itag_main">
          <div class="itag_li">
            <ul>
              <li v-for="(item, index) in dataList.hangYeHuoDong" :key="index">
                <span>[{{ item.post_date.split(" ")[0] }}]</span>
                <i>•</i>
                <a :href="'/#/detail?id=' + item.ID" target='_blank'
                   :title='item.post_title'>
                  {{ item.post_title }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!--新闻5-->
      <div class="ibox itag ">
        <h3><a href="/#/quanQiuZiXun" target="_blank" title="全球资讯" class="on">全球资讯</a></h3>
        <div class="itag_main">
          <div class="itag_li">
            <ul>
              <li v-for="(item, index) in dataList.quanQiuZiXun" :key="index">
                <span>[{{ item.post_date.split(" ")[0] }}]</span>
                <i>•</i>
                <a :href="'/#/detail?id=' + item.ID" target='_blank'
                   :title='item.post_title'>
                  {{ item.post_title }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!--新闻6-->
      <div class="ibox itag mr0">
        <h3><a href="/#/guoNeiZiXun" target="_blank" title="国内资讯" class="on">国内资讯</a></h3>
        <div class="itag_main">
          <div class="itag_li">
            <ul>
              <li v-for="(item, index) in dataList.guoNeiZiXun" :key="index">
                <span>[{{ item.post_date.split(" ")[0] }}]</span>
                <i>•</i>
                <a :href="'/#/detail?id=' + item.ID" target='_blank'
                   :title='item.post_title'>
                  {{ item.post_title }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="interlink">
      <div class="interlink__inner">
        <div class="interlink__title">友情链接</div>
        <div class="interlink__list"><a href="http://www.xhlgg.cn" target="_blank"
                                        class="interlink__item">咸阳广告公司</a><a
            href="http://www.boertl.com" target="_blank" class="interlink__item">贵州涂料</a><a
            href="http://www.jinyayang.net" target="_blank" class="interlink__item">外墙真石漆</a><a
            href="http://www.syshspcn.com" target="_blank" class="interlink__item">沈阳奢侈品高价回收</a><a
            href="http://www.scshcsy.com" target="_blank" class="interlink__item">四川芝麻白</a><a
            href="http://gj.zzgjkd.com" target="_blank" class="interlink__item">郑州国际快递</a><a
            href="http://www.kmlucheng.com" target="_blank" class="interlink__item">道路划线</a><a
            href="http://www.ytxghl.com" target="_blank" class="interlink__item">阳台护栏</a><a
            href="http://www.gzyjxny.cn" target="_blank" class="interlink__item">新能源纯电动面包车</a><a
            href="http://www.yunguanjia.vip" target="_blank" class="interlink__item">西安注册公司</a></div>
      </div>
    </div>
  </div>
  <Footer/>
</template>

<script>
// @ is an alias to /src

import Header from "@/components/Header"
import Footer from "@/components/Footer"
import http from "@/util/http"

let interval

export default {
  name: 'HomeView',
  components: {
    Footer,
    Header
  },
  data() {
    return {
      bannerI: 0,
      bannerHref: undefined,
      dataList: [],
      banner: []
    }
  },
  mounted() {
    this._getBannerList()
    this._getList()
  },
  unmounted() {
    interval && clearInterval(interval)
  },
  methods: {
    _bannerChange() {
      this.bannerHref = this.banner[0].b_img
      interval = setInterval(() => {
        this.bannerHref = this.bannerI === 0 ? this.banner[1].b_img : this.banner[0].b_img
        this.bannerI = this.bannerI === 0 ? 1 : 0
      }, 3000)
    },
    _getList() {
      http.get('homePage')
          .then((res) => {
            if (res.data.status === 0) {
              this.dataList = res.data.data
            }
          })
    },
    _getBannerList() {
      http.get('bannerList')
          .then((res) => {
            if (res.data.status === 0) {
              this.banner = res.data.data

              this._bannerChange()
            }
          })
    }
  }
}
</script>
<style scoped>
ul {
  line-height: 1.5;
}
</style>
